import { render, staticRenderFns } from "./password-reset-success.vue?vue&type=template&id=de944fe8&scoped=true"
import script from "./password-reset-success.vue?vue&type=script&lang=js"
export * from "./password-reset-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de944fe8",
  null
  
)

export default component.exports